import { render, staticRenderFns } from "./NewEditGestaoDeAulaPage.vue?vue&type=template&id=6a73e455"
import script from "./NewEditGestaoDeAulaPage.vue?vue&type=script&lang=js"
export * from "./NewEditGestaoDeAulaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports